<div class="condition-row">
  <div class="condition-row__fields">
    <!-- Field select -->
    <mat-form-field class="condition-row__field condition-row__field--grouped" appearance="outline">
      <mat-select
        [formControl]="fieldControl"
        [placeholder]="'workflows.builder.select_field' | translate"
        panelClass="workflow-condition-row__field-panel"
      >
        <mat-optgroup *ngFor="let group of conditionFieldGroups" [label]="group.label">
          <mat-option *ngFor="let field of group.options" [value]="field.key">
            {{ getFieldLabel(field) }}
          </mat-option>
        </mat-optgroup>
      </mat-select>
    </mat-form-field>

    <!-- Operator select -->
    <ui-form-field
      class="condition-row__operator"
      type="select"
      [formControl]="operatorControl"
      [placeholder]="'workflows.builder.select_operator' | translate"
      [options]="operatorOptions"
    ></ui-form-field>

    <!-- Value input (hidden for is_empty / is_not_empty) -->
    <ng-container *ngIf="!hideValue">
      <ng-container [ngSwitch]="selectedField?.dataType">
        <!-- Boolean -->
        <ui-form-field
          *ngSwitchCase="'boolean'"
          class="condition-row__value"
          type="select"
          [formControl]="valueControl"
          [options]="booleanOptions"
        ></ui-form-field>

        <!-- Enum -->
        <!-- Placeholder logic lives in enumValuePlaceholder: single-select drops it
             once options load (first item is auto-selected), but keeps it while the
             enum list is still loading; multi-select (in/not_in) always shows it. -->
        <ui-form-field
          *ngSwitchCase="'enum'"
          class="condition-row__value"
          type="select"
          [formControl]="valueControl"
          [placeholder]="enumValuePlaceholder"
          [options]="enumOptions"
          [multiple]="isEnumListOperator"
        ></ui-form-field>

        <!-- Multi enum -->
        <div *ngSwitchCase="'multi_enum'" class="condition-row__value condition-row__value--chips">
          <mat-chip-list #multiEnumChipList [attr.aria-label]="'workflows.builder.enter_multiple_values' | translate">
            <mat-chip
              *ngFor="let option of selectedMultiEnumOptions"
              [removable]="true"
              (removed)="removeMultiEnumOption(option)"
            >
              <span class="condition-row__chip-text" [title]="option.label">{{ option.label }}</span>
              <mat-icon matChipRemove>close</mat-icon>
            </mat-chip>
            <input
              class="condition-row__chip-input"
              [placeholder]="'workflows.builder.enter_multiple_values' | translate"
              [formControl]="chipSearchControl"
              [matAutocomplete]="multiEnumAuto"
              [matChipInputFor]="multiEnumChipList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matChipInputAddOnBlur]="false"
              (matChipInputTokenEnd)="addMultiEnumFromInput($event)"
            />
          </mat-chip-list>
          <mat-autocomplete
            #multiEnumAuto="matAutocomplete"
            class="workflow-condition-row__autocomplete-panel"
            [displayWith]="displayEnumOption"
            panelWidth="420px"
            (optionSelected)="selectMultiEnumOption($event.option.value)"
          >
            <mat-option *ngFor="let option of filteredMultiEnumOptions$ | async" [value]="option">
              {{ option.label }}
            </mat-option>
          </mat-autocomplete>
        </div>

        <!-- Number -->
        <ui-form-field
          *ngSwitchCase="'number'"
          class="condition-row__value"
          type="number"
          [formControl]="valueControl"
          [placeholder]="'workflows.builder.enter_value' | translate"
        ></ui-form-field>

        <!-- String (default) -->
        <ng-container *ngSwitchDefault>
          <div
            *ngIf="isKeywordListOperator; else stringValueInput"
            class="condition-row__value condition-row__value--chips"
          >
            <mat-chip-list #keywordChipList [attr.aria-label]="'workflows.builder.enter_multiple_keywords' | translate">
              <mat-chip
                *ngFor="let keyword of keywordChips"
                [removable]="true"
                (removed)="removeKeyword(keyword)"
              >
                <span class="condition-row__chip-text" [title]="keyword">{{ keyword }}</span>
                <mat-icon matChipRemove>close</mat-icon>
              </mat-chip>
              <input
                class="condition-row__chip-input"
                [placeholder]="'workflows.builder.enter_multiple_keywords' | translate"
                [matChipInputFor]="keywordChipList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="true"
                (matChipInputTokenEnd)="addKeyword($event)"
              />
            </mat-chip-list>
          </div>

          <ng-template #stringValueInput>
            <ui-form-field
              class="condition-row__value"
              type="text"
              [formControl]="valueControl"
              [placeholder]="'workflows.builder.enter_value' | translate"
            ></ui-form-field>
          </ng-template>
        </ng-container>
      </ng-container>
    </ng-container>
    <!-- Locked rows show the lock in place of the remove button: without it a row
         with no delete affordance just looks broken. -->
    <span
      *ngIf="locked; else removeButton"
      class="condition-row__lock"
      [matTooltip]="'workflows.builder.locked_condition_tooltip' | translate"
      matTooltipPosition="above"
    >
      <ui-svg-icon svgIcon="lock" size="medium"></ui-svg-icon>
    </span>
    <ng-template #removeButton>
      <ui-button
        type="transparent"
        class="condition-row__remove"
        [icon]="'close-cc'"
        (click)="remove()"
      ></ui-button>
    </ng-template>
  </div>
</div>
